import { render, staticRenderFns } from "./EmailLayoutEditPage.vue?vue&type=template&id=c144f19e&scoped=true&"
import script from "./EmailLayoutEditPage.vue?vue&type=script&lang=ts&"
export * from "./EmailLayoutEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmailLayoutEditPage.vue?vue&type=style&index=0&id=c144f19e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c144f19e",
  null
  
)

export default component.exports